export default "__VITE_ASSET__BcGZiczg__"